/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Verified_ButtonInputs */

const en_login_verified_button = /** @type {(inputs: Login_Verified_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I've Verified My Email`)
};

const fr_login_verified_button = /** @type {(inputs: Login_Verified_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`J'ai Vérifié Mon Email`)
};

const de_login_verified_button = /** @type {(inputs: Login_Verified_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ich habe meine E-Mail-Adresse bestätigt.`)
};

const it_login_verified_button = /** @type {(inputs: Login_Verified_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ho verificato la mia email`)
};

const ru_login_verified_button = /** @type {(inputs: Login_Verified_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Я подтвердил свой адрес электронной почты.`)
};

const es_login_verified_button = /** @type {(inputs: Login_Verified_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`He verificado mi correo electrónico`)
};

const zh_cn2_login_verified_button = /** @type {(inputs: Login_Verified_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我已经验证了我的邮箱`)
};

const ja_login_verified_button = /** @type {(inputs: Login_Verified_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`メールを確認しました`)
};

const hi_login_verified_button = /** @type {(inputs: Login_Verified_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैंने अपना ईमेल सत्यापित कर लिया है`)
};

const pt_pt2_login_verified_button = /** @type {(inputs: Login_Verified_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Verifiquei meu e-mail.`)
};

/**
* | output |
* | --- |
* | "I've Verified My Email" |
*
* @param {Login_Verified_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const login_verified_button = /** @type {((inputs?: Login_Verified_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Verified_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_login_verified_button(inputs)
	if (locale === "de") return de_login_verified_button(inputs)
	if (locale === "it") return it_login_verified_button(inputs)
	if (locale === "ru") return ru_login_verified_button(inputs)
	if (locale === "es") return es_login_verified_button(inputs)
	if (locale === "zh-CN") return zh_cn2_login_verified_button(inputs)
	if (locale === "ja") return ja_login_verified_button(inputs)
	if (locale === "hi") return hi_login_verified_button(inputs)
	if (locale === "pt-PT") return pt_pt2_login_verified_button(inputs)
	return en_login_verified_button(inputs)
});